import React, { useContext, useEffect ,useState} from 'react'

//Components
import Header from "../Components/ProfileRegisterationOtp/Header"
import OtpSection from '../Components/ProfileRegisterationOtp/OtpSection'
import Bannersection from '../Components/ProfileRegisterationOtp/Bannersection'
import MobileviewOptSection from '../Components/ProfileRegisterationOtp/MobileviewOptSection'
import Footer from '../Components/Footer/Footer'
import MobileFooter from './Footer/MobileFooter'
import Loader from "../Components/Loader";
import $ from "jquery"

//context
import { LoginContext } from '../Contexts/LoginContext'
import Constants from '../Constants/constants'

const ProfileRegisterationOtp = (props) => {

  const [isLoadingProfile, setisLoadingProfile] = useState(true); 
  const {logout} = useContext(LoginContext)
  const isCommunitySite = localStorage.getItem(Constants.loginLocalStorageKeys.isCommunitySite);
  useEffect(() => {
    setisLoadingProfile(false)
    // alert(window.location.href)
    window.onpopstate = ()=> {
        if(window.location.href.indexOf('dashboard')>-1 || window.location.href.indexOf('mobileVerification')>-1){
          logout();
        }
      }
  },[])

  const scriptToInject = 
  !isCommunitySite &&
  
  `
  <div class="pixelScript">
  <!-- Google tag (gtag.js) -->
  <script async src="https://www.googletagmanager.com/gtag/js?id=AW-875555676"></script>
  <script>
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
  
    gtag('config', 'AW-875555676');
  </script>
<!-- Taboola Pixel Code -->
<script type='text/javascript'>
  window._tfa = window._tfa || [];
  window._tfa.push({notify: 'event', name: 'page_view', id: 1728611});
  !function (t, f, a, x) {
         if (!document.getElementById(x)) {
            t.async = 1;t.src = a;t.id=x;f.parentNode.insertBefore(t, f);
         }
  }(document.createElement('script'),
  document.getElementsByTagName('script')[0],
  '//cdn.taboola.com/libtrc/unip/1728611/tfa.js',
  'tb_tfa_script');
</script>
<!-- End of Taboola Pixel Code -->


<script>(function(w,d,t,r,u){var f,n,i;w[u]=w[u]||[],f=function(){var o={ti:"97181359",
     enableAutoSpaTracking: true};o.q=w[u],w[u]=new UET(o),w[u].push("pageLoad")},n=d.createElement(t),n.src=r,n.async=1,n.onload=n.onreadystatechange=function()
     {var s=this.readyState;s&&s!=="loaded"&&s!=="complete"||(f(),n.onload=n.onreadystatechange=null)},i=d.getElementsByTagName(t)[0],i.parentNode.insertBefore(n,i)})
    (window,document,"script","//bat.bing.com/bat.js","uetq");</script>
    <script data-obct type = "text/javascript">
  /** DO NOT MODIFY THIS CODE**/
  !function(_window, _document) {
    var OB_ADV_ID = '00092231c98bb4d2f5ef796524f1cd041d';
    if (_window.obApi) {
      var toArray = function(object) {
        return Object.prototype.toString.call(object) === '[object Array]' ? object : [object];
      };
      _window.obApi.marketerId = toArray(_window.obApi.marketerId).concat(toArray(OB_ADV_ID));
      return;
    }
    var api = _window.obApi = function() {
      api.dispatch ? api.dispatch.apply(api, arguments) : api.queue.push(arguments);
    };
    api.version = '1.1';
    api.loaded = true;
    api.marketerId = OB_ADV_ID;
    api.queue = [];
    var tag = _document.createElement('script');
    tag.async = true;
    tag.src = '//amplify.outbrain.com/cp/obtp.js';
    tag.type = 'text/javascript';
    var script = _document.getElementsByTagName('script')[0];
    script.parentNode.insertBefore(tag, script);
  }(window, document);

  obApi('track', 'PAGE_VIEW');
</script>

<!-- Outbrain DSP Pixel TYROO_KALYAN-MATRIMONY_DIRECT pixel -->
<script type="text/javascript">
    !function(_window, _document) {
        var ZEM_TAG_ID='134263';
        if (_window.zemApi) {var toArray = function(object) {    return Object.prototype.toString.call(object) === '[object Array]' ? object : [object];};_window.zemApi.marketerId = toArray(_window.zemApi.marketerId).concat(toArray(ZEM_TAG_ID));return;}
        var api = _window.zemApi = function() {api.dispatch ? api.dispatch.apply(api, arguments) : api.queue.push(arguments);};api.version = '1.0';api.loaded = true;api.marketerId = ZEM_TAG_ID;api.queue = [];var tag = _document.createElement('script');tag.async = true;tag.src = '//js-tag.zemanta.com/zcpt.js';tag.type = 'text/javascript';var script = _document.getElementsByTagName('script')[0];script.parentNode.insertBefore(tag, script);
    }(window, document);
    zemApi('track', 'PAGE_VIEW');
</script>
<noscript><img src="//p1.zemanta.com/v2/p/ns/134263/PAGE_VIEW/" referrerpolicy="no-referrer-when-downgrade" height="1" width="1" border="0" alt="" /></noscript>
  <!-- Google Tag Manager -->
<script>(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-NRQ9QZX5');</script>
<!-- End Google Tag Manager -->
</div>
  

  `;

  const gtmscript = `<!-- Google Tag Manager -->
<script class="gtmscript">(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-PJ95CPWZ');</script>
<!-- End Google Tag Manager -->`;

  const noScript = `<!-- Google Tag Manager (noscript) -->
      <noscript class="gtmnoscript"><iframe src="https://www.googletagmanager.com/ns.html?id=GTM-PJ95CPWZ"
      height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>
      <!-- End Google Tag Manager (noscript) --> <!-- Google Tag Manager (noscript) -->
<noscript><iframe src="https://www.googletagmanager.com/ns.html?id=GTM-NRQ9QZX5"
height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>
<!-- End Google Tag Manager (noscript) -->`;


  useEffect(() => {
    if(isCommunitySite){
      //no script for this community site
    }else{
      if ($('.pixelScript').length > 0) {
        $('.pixelScript').remove()
        $('head').append(scriptToInject)
      } else {
        document.head.insertAdjacentHTML("beforeend", scriptToInject);
      }

      if(document.getElementsByClassName("gtmscript").length > 0){
          //no script for this
      }else{
        document.head.insertAdjacentHTML("beforeend", gtmscript);
      }

      if(document.getElementsByClassName("gtmnoscript").length > 0 ){
        // no script for this
      }else{
        document.body.insertAdjacentHTML("afterbegin", noScript);
      }
	  }
    return () => {
      $('.pixelScript').remove()
    }
  }, [])

  return (
    <div className='min-h-0 flex-1 overflow-hidden'>
      <Header />
      <main className=" font-segeo ">
        <div className="overflow-x-hidden">
        {isLoadingProfile ?  
                  <Loader /> : 
          <div className=" hidden  md:grid md:grid-cols-9 ">
            <OtpSection />
            <Bannersection />
          </div>
          }
          {/* mobileview */}

          <div className=" px-[1rem] mt-[2rem]  md:hidden ">
            <MobileviewOptSection />
            <Bannersection />

          </div>

        </div>
      </main>
      <div className='md:fixed md:right-0 md:bottom-0 lg:relative '>
      <Footer />
      </div>
      <MobileFooter/>

    </div>
  )
}

export default ProfileRegisterationOtp
